import { render, staticRenderFns } from "./CampaignActionType.vue?vue&type=template&id=483f3786&lang=pug"
import script from "./CampaignActionType.vue?vue&type=script&lang=js"
export * from "./CampaignActionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports